import React from 'react';
import { getText } from '../../utils/functions';
import { useIcons, useIntelliTags } from '../../utils/hooks';

/**
 * Regular NavBar for any screen except Home
 */

function ImportantInfo({
	colors,
	translate,
	portal,
	classNameDIV = 'flex w-full font-lato py-2 bg-red-700 justify-around',
	classNameInnerDIV = 'flex max-w-screen-2xl md:mx-auto font-lato text-lg px-5 md:px-0 space-x-5 items-center',
}) {
	/* Icon hook */
	const { Alert } = useIcons(colors);
	const { applyIntelliTags } = useIntelliTags({ portal, translate });
	const defaultStyleDIV = {
		color: colors.secondary,
		backgroundColor: colors?.warning,
	};
	const defaultStyleAlert = {
		fill: colors?.secondary,
	};
	return <div
		id='ImportantInfo'
		className={classNameDIV}
		style={defaultStyleDIV}
	>
		<div
			id='InnerDiv'
			className={classNameInnerDIV}
		>
			<div className='flex items-center'>
				{Alert({
					className: 'h-6 w-6 md:h-10 md:w-10',
					style: defaultStyleAlert
				})
				}
			</div>
			<div>
				<span className='text-left text-sm md:text-base'>
					{applyIntelliTags(getText(portal?.config?.home?.highlighted, translate))}
				</span>
			</div>
		</div>
	</div>;
}
export default ImportantInfo;
